var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-light p-4"},[_vm._v(" No options available ")])
}
var staticRenderFns = []

export { render, staticRenderFns }